module.exports = __webpack_public_path__ + "static/media/curse-arrow.375abf13.svg";